import { Box } from "@mui/material"
import React, { useState } from "react"
import { useMediaQuery } from "react-responsive"
import { MENU_TYPE, SUB_MENU_TYPE } from "src/modules/const"
import { CommonLayout } from "../CommonLayout"
import { TopMenuItem } from "../TopMenuItem"
import { AdministratorListPage } from "./layout/AdministratorListPage"
import { AdministratorRegisterPage } from "./layout/AdministratorRegisterPage"
import { AdviserListPage } from "./layout/AdviserListPage"
import { AdviserRegisterPage } from "./layout/AdviserRegisterPage"
import { CompanyListPage } from "./layout/CompanyListPage"
import { CompanyRegisterPage } from "./layout/CompanyRegisterPage"
import { UserInvitePage } from "./layout/UserInvitePage"
import { UserListPage } from "./layout/UserListPage"
import { UserRegisterPage } from "./layout/UserRegisterPage"
import { UserSearchItem } from "./layout/UserSearchItem"

interface Props {
  subMenuIndex: number
}

export const UsersPage = ({ subMenuIndex }: Props) => {
  const [areaID, setAreaID] = useState<number[]>([])
  const [keyword, setKeyword] = useState<string>("")

  const subMenu = [
    {
      title: "user_list",
      icon: "register_information",
      index: SUB_MENU_TYPE.USER_LIST,
      page: <UserListPage areaID={areaID} keyword={keyword} />,
      search: (
        <UserSearchItem
          areaID={areaID}
          handleAreaID={setAreaID}
          keyword={keyword}
          handleKeyword={setKeyword}
        />
      ),
      link: "/users/list/member",
    },
    {
      title: "adviser_list",
      icon: "adviser",
      index: SUB_MENU_TYPE.ADVISER_LIST,
      page: <AdviserListPage areaID={areaID} />,
      search: <UserSearchItem areaID={areaID} handleAreaID={setAreaID} />,
      link: "/users/list/adviser",
    },
    {
      title: "company_list",
      icon: "company",
      index: SUB_MENU_TYPE.COMPANY_LIST,
      page: <CompanyListPage areaID={areaID} />,
      search: <UserSearchItem areaID={areaID} handleAreaID={setAreaID} />,
      link: "/users/list/company",
    },
    {
      title: "administrator_list",
      icon: "password_change",
      index: SUB_MENU_TYPE.ADMINISTRATOR_LIST,
      page: <AdministratorListPage areaID={areaID} />,
      search: <UserSearchItem areaID={areaID} handleAreaID={setAreaID} />,
      link: "/users/list/administrator",
    },
    {
      title: "new_user",
      icon: "new_user",
      index: SUB_MENU_TYPE.USER_MEMBER,
      page: <UserRegisterPage />,
      search: null,
      link: "/users/member",
    },
    {
      title: "new_adviser",
      icon: "new_adviser",
      index: SUB_MENU_TYPE.USER_ADVISER,
      page: <AdviserRegisterPage />,
      search: null,
      link: "/users/adviser",
    },
    {
      title: "new_company",
      icon: "new_company",
      index: SUB_MENU_TYPE.USER_COMPANY,
      page: <CompanyRegisterPage />,
      search: null,
      link: "/users/company",
    },
    {
      title: "new_administrator",
      icon: "new_administrator",
      index: SUB_MENU_TYPE.USER_ADMIN,
      page: <AdministratorRegisterPage />,
      search: null,
      link: "/users/admin",
    },
    {
      title: "invite_user",
      icon: "invite_user",
      index: SUB_MENU_TYPE.INVITE_USER,
      page: <UserInvitePage />,
      search: null,
      link: "/users/invite",
    },
  ]

  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })
  return (
    <>
      {isTablet ? (
        <></>
      ) : (
        <Box position="absolute" sx={{ width: "100%", height: "60px" }}>
          <Box display="flex">
            <TopMenuItem
              mainMenuIndex={MENU_TYPE.USER_MANAGE}
              subMenuIndex={subMenuIndex}
              areaID={areaID}
              handleAreaID={setAreaID}
            />
          </Box>
        </Box>
      )}

      <CommonLayout subMenu={subMenu} subMenuIndex={subMenuIndex} />
    </>
  )
}
